import React from 'react';
import {orderDiscountPricing} from './utils';

export default function PaymentDetails({
  orderData,
  isInst,
  totalInstallmentAmount,
  totalSquareAmount,
  totalPlatformFess,
  totalAmountTransferedToCoach,
}) {
  // Derive the displayed payment method name
  let paymentMethodName = orderData?.order?.payment_method;
  if (paymentMethodName === 'pay_later') paymentMethodName = 'Not paid yet';
  if (paymentMethodName === 'square') paymentMethodName = 'By Credit Card (Square)';
  if (paymentMethodName === 'pay_now_other') paymentMethodName = 'By other(Venmo, PayPal..)';
  if (paymentMethodName === 'pay_now_cash') paymentMethodName = 'By Cash';
  if (orderData?.order.paymentStatus === 'unpaid') paymentMethodName = 'Not paid yet';
  const discountPricing = orderDiscountPricing(orderData?.order);
  console.log('order5555', orderData);
  return (
    <div className="col-md-4 client-details">
      <div className="client-info">
        <div className="card shadow-sm">
          <div className="card-header" style={{backgroundColor: '#404040', color: 'white'}}>
            Payment Details
          </div>
          <div className="card-body p-0 pb-4">
            <br />
            <ul className="list-group list-group-flush">
              <li
                className="d-flex justify-content-left align-items-center"
                style={{border: '0px none'}}
              >
                <strong style={{width: '220px', display: 'inline-block'}}>
                  &nbsp;&nbsp;&nbsp;Payment Status:
                </strong>
                <span style={{float: 'right', marginRight: '14px'}}>
                  {orderData.order?.cancelType === undefined &&
                    orderData?.order?.cancelType !== 'refund' && (
                      <span
                        style={{
                          color: orderData?.order?.paymentStatus === 'paid' ? 'green' : 'red',
                        }}
                      >
                        <b>{(orderData?.order.paymentStatus || '').toUpperCase()}</b>
                      </span>
                    )}
                  {orderData.order.cancelType === 'refund' && (
                    <div>
                      {orderData.order.refundPaymentStatus === 'partiallyRefunded'
                        ? 'PARTIALLY REFUNDEND'
                        : (orderData.order.refundPaymentStatus || '').toUpperCase()}
                      {orderData.order.refundArr && (
                        <div>
                          Refunded Amounts:
                          {orderData.order.refundArr.map((r, i) => {
                            return <div key={'refundedAmounts' + i}>${parseFloat(r.amount).toFixed(2)}</div>;
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </span>
              </li>
              <br />
              <li
                className="d-flex justify-content-left align-items-center"
                style={{border: '0px none'}}
              >
                <strong style={{width: '220px', display: 'inline-block'}}>
                  &nbsp;&nbsp;&nbsp;Payment Method:
                </strong>
                <span style={{float: 'right', marginRight: '14px'}}>{paymentMethodName}</span>
              </li>
              <br />
              {orderData.square != null && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Card:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      {orderData.square?.last_4 && <span>****** {orderData.square?.last_4}</span>}
                      {orderData.square?.exp_month && (
                        <span>
                          , <b>Exp.</b>: {orderData.square?.exp_month}
                        </span>
                      )}
                      {orderData.square?.exp_year && <span>/{orderData.square?.exp_year}</span>}
                      {orderData.square?.card_brand && (
                        <span>
                          , <b>{orderData.square?.card_brand}</b>
                        </span>
                      )}
                    </span>
                  </li>
                  <br />
                </>
              )}

              {orderData?.square_business_name != null && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Connected Square Account:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      {orderData.square_business_name}
                    </span>
                  </li>
                  <br />
                </>
              )}

              {orderData.square?.status != null && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Square Payment Status:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      {orderData.square?.status}
                    </span>
                  </li>
                  <br />
                </>
              )}
              {orderData.square?.refunded_money?.amount != null && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Square Refunded Amount:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      {orderData.square?.refunded_money?.currency}{' '}
                      {(orderData.square?.refunded_money?.amount / 100).toFixed(2)}
                    </span>
                  </li>
                  <br />
                </>
              )}
              {orderData.square?.receipt_url && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Square Receipt:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <a
                        style={{color: 'red'}}
                        target="_blank"
                        rel="noreferrer"
                        href={orderData.square?.receipt_url}
                      >
                        Receipt
                      </a>
                    </span>
                  </li>
                  <br />
                </>
              )}
              {discountPricing ? (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Original Service Price:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"></i>{discountPricing.originalPrice}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Discount Code Applied:
                    </strong>
                    <span style={{color: 'green', float: 'right', marginRight: '14px'}}>
                      {discountPricing.code}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Amount Saved:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"></i>{discountPricing.amountSaved}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Your Price:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"></i>{discountPricing.finalPrice}
                    </span>
                  </li>
                  <br />
                </>
              ) : null}
              {/* {orderData.order.payment_method === 'square' && !orderData.order.SquareType && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Square Fees:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"></i>{' '}
                      {isInst
                        ? totalSquareAmount.toFixed(2)
                        : (orderData.square?.processing_fee / 100).toFixed(2)}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Platform Fees:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"></i>{' '}
                      {isInst
                        ? totalPlatformFess.toFixed(2)
                        : (orderData.square?.app_fee_money / 100).toFixed(2)}
                    </span>
                  </li>
                  <br />
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Amount Transferred To Coach:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"> </i>
                      {isInst
                        ? totalAmountTransferedToCoach.toFixed(2)
                        : (
                            orderData.square?.total_money / 100 -
                            orderData.square?.processing_fee / 100 -
                            orderData.square?.app_fee_money / 100
                          ).toFixed(2)}
                    </span>
                  </li>
                  <br />
                </>
              )}
              {orderData.order.payment_method === 'square' && (
                <>
                  <li
                    className="d-flex justify-content-left align-items-center"
                    style={{border: '0px none'}}
                  >
                    <strong style={{width: '220px', display: 'inline-block'}}>
                      &nbsp;&nbsp;&nbsp;Total Amount:
                    </strong>
                    <span style={{float: 'right', marginRight: '14px'}}>
                      <i className="fa fa-usd"> </i>
                      {isInst
                        ? totalInstallmentAmount.toFixed(2)
                        : orderData.order?.SquareType
                        ? (orderData.order?.SquareTotalMoney / 100).toFixed(2)
                        : (orderData.square?.total_money / 100).toFixed(2)}
                    </span>
                  </li>
                  <br />
                </>
              )} */}

            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
